<template>
  <div class="post-webwidget-v2-player-audio-player" :class="audioPlayerClassList">
    <audio
      v-el:audio-player
      :autoplay="autoplay"
      @abort="onAbort"
      @canplay="onCanPlay"
      @durationchange="onDurationChange"
      @emptied="onEmptied"
      @ended="onEnded"
      @error="onError"
      @loadeddata="onLoadedData"
      @pause="onPause"
      @play="onPlay"
      @playing="onPlaying"
      @progress="onProgress"
      @seeked="onSeeked"
      @seeking="onSeeking"
      @stalled="onStalled"
      @suspend="onSuspend"
      @timeupdate="onTimeUpdate"
      @volumechange="onVolumeChange"
      @waiting="onWaiting"
    >
      <source :src="audioFileSrc" />
    </audio>
    <div class="post-webwidget-v2-player-audio-player-controls">
      <div class="post-webwidget-v2-player-audio-player-controls-left-side">
        <div class="post-webwidget-v2-player-audio-player-controls__play-toggle" @click="onPlayToggleButton">
          <img :src="playToggleButton" width="30" height="30" />
        </div>
      </div>
      <div class="post-webwidget-v2-player-audio-player-controls-right-side">
        <div class="post-webwidget-v2-player-audio-player-progress-bar" @click="onProgressBarClick">
          <!--
           <div class="post-webwidget-v2-player-audio-player-progress-bar__buffered" :style="bufferedBarStyle"></div>
          -->
          <div class="post-webwidget-v2-player-audio-player-progress-bar__played" :style="progressBarStyle"></div>
        </div>
        <div class="post-webwidget-v2-player-audio-player-progress-text">
          <template v-if="audioFileSrc">
            <div>
              <template v-if="loadedMediaData">
                <div v-if="playingLiveStream">LIVE</div>
                <div v-else>{{ formattedTimePlayed }} / {{ formattedDuration }}</div>
              </template>
              <template v-else>
                Buffering...
              </template>
            </div>
          </template>
          <template v-else>
            <div>Select an episode</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// This file should be refactored.

import moment from 'moment'; // remove this dependency by manually formatting using locale strings

export default {
  name: 'viblast-audio-player',
  props: {
    darkTheme: Boolean,
    audioFileSrc: String,
    autoplay: {
      type: Boolean,
      default: false,
    },
    playingLiveStream: Boolean,
  },
  data() {
    return {
      loadedMediaData: false,
      fileLoadProgress: undefined,
      buffered: undefined,
      fileSize: undefined,
      isPlaying: false,
      canPlay: false,
      viblastKey: 'ebb0b350-fb99-4e69-8337-0b18f080df4a',
      duration: undefined,
      currentTime: undefined,
    };
  },
  computed: {
    audioPlayerClassList() {
      return {
        'post-webwidget-v2-player-audio-player--dark-theme': this.darkTheme,
      };
    },

    bufferedPercentage() {
      return (this.buffered / this.duration) * 100 || 0;
    },

    bufferedBarStyle() {
      return {
        width: `${this.bufferedPercentage}%`,
      };
    },

    progress() {
      return (this.currentTime / this.duration) || 0;
    },

    progressBarStyle() {
      return {
        width: `${this.progress * 100}%`,
      };
    },

    // scrubPosition() {
      // This should be used if a input[type="range"] is ever used
      // Seek position or current position
      // return this.progress;
    // },

    playToggleButton() {
      return this.isPlaying ? this.pauseButtonImage : this.playButtonImage;
    },

    playButtonImage() {
      return this.darkTheme ? require('../../static/icons/white/svg/play.svg') : require('../../static/icons/grey/svg/play.svg');
    },

    pauseButtonImage() {
      return this.darkTheme ? require('../../static/icons/white/svg/pause.svg') : require('../../static/icons/grey/svg/pause.svg');
    },

    formattedTimePlayed() {
      // TODO: If over an hour show hours format
      return moment.utc((this.currentTime || 0) * 1000).format('HH:mm:ss');
    },

    formattedDuration() {
      // TODO: If over an hour show hours format
      return moment.utc(this.duration * 1000).format('HH:mm:ss');
    },

    useM4a() {
      return this.audioFileSrc && this.audioFileSrc.includes('m4a');
    },
  },
  methods: {
    resetData() {
      this.loadedMediaData = false;
      this.isPlaying = false;
      this.canPlay = false;
      this.currentTime = undefined;
      this.duration = undefined;
    },
    onAbort() {
      //
    },
    onCanPlay() {
      this.canPlay = true;
    },
    onDurationChange({ target }) {
      this.duration = target.duration;
    },
    onEmptied() {
      this.resetData();
    },
    onEnded() {
      this.isPlaying = false;
      this.$emit('episode-ended');
    },
    onError(event) {
      // eslint-disable-next-line no-console
      console.log(event);
    },
    onLoadedData({ target }) {
      this.loadedMediaData = true;
      this.duration = target.duration;
    },
    onPause() {
      this.isPlaying = false;
      this.$emit('pause');
    },
    onPlay() {
      this.canPlay = true;
      this.isPlaying = true;
      this.$emit('play');
    },
    onPlaying() {
      //
    },
    onProgress() {
      // this.buffered = target.buffered.end(0);
    },
    onProgressBarClick(event) {
      if (this.playingLiveStream) {
        return;
      }
      const seekToProgressPercentage = event.offsetX / event.target.offsetWidth;
      const newCurrentTime = seekToProgressPercentage * this.duration;
      this.$els.audioPlayer.currentTime = newCurrentTime;
    },
    onSeeked() {
      //
    },
    onSeeking() {
      //
    },
    onStalled() {
      //
    },
    onSuspend() {
      //
    },
    onTimeUpdate(event) {
      this.currentTime = event.target.currentTime;
    },
    onVolumeChange() {
      //
    },
    onWaiting() {
      //
    },
    onPlayToggleButton() {
      if (!this.canPlay) {
        return;
      }

      if (this.$els.audioPlayer.paused) {
        this.$els.audioPlayer.play()
        .then(() => {
          this.isPlaying = true;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
      } else {
        this.$els.audioPlayer.pause();
      }
    },
  },
  ready() {
    this.$emit('ready', this.$els.audioPlayer);
  },
  watch: {
    audioFileSrc(newStreamSrc) {
      if (!window.viblast) {
        return;
      }

      this.resetData();

      const { audioPlayer } = this.$els;
      window.viblast(audioPlayer).stop();

      if (this.useM4a) {
        audioPlayer.setAttribute('src', newStreamSrc);
        audioPlayer.play()
          // eslint-disable-next-line no-console
          .catch(e => console.error(e));
        return;
      }

      try {
        window.viblast(audioPlayer).setup({
          key: this.viblastKey,
          stream: newStreamSrc,
          forceHEAAC: true,   // Required on Chrome
          autoplay: this.autoplay,
        });
      } catch (e) {
        //
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/variables-v2';
.post-webwidget-v2-player-audio-player {
  &-controls {
    display: flex;
    width: 100%;
    align-items: center;

    &-left-side {
      margin-right: 1em;
    }

    &-right-side {
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: center;
    }


    &__play-toggle {
      cursor: pointer;
    }
  }

  &-progress-text {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 0.7em;
  }

  &-progress-bar {
    margin-bottom: 0.5em;
    position: relative;
    cursor: pointer;
    width: 100%;
    height: 10px;
    background: $audioPlayerProgressBackground;
    border-radius: 2.5px; // half of $borderRadius
    box-shadow: 0px 0px 1px $borderColor;

    /*
    &__buffered {
      position: absolute;
      height: 100%;
      background: $audioPLayerBufferedProgressBackground;
      border-radius: 2.5px;
    }
    */

    &__played {
      pointer-events: none; // Neccessary to ignore click so the parent div can catch the event and determine where to seek
      position: absolute;
      z-index: 2;
      height: 100%;
      background: $audioPlayerPlayedProgressBackground;
      border-radius: 2.5px; // half of $borderRadius
    }
  }

  &--dark-theme {
    .post-webwidget-v2-player-audio-player {
      &-progress-bar {
        background: $darkThemeAudioPlayerProgressBackground;
        box-shadow: 0px 0px 1px $darkThemeBorderColor;
        &__played {
          background: $darkThemeAudioPlayerPlayedProgressBackground;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ViblastAudioPlayer.vue?582601e1